import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Box, Grid, Typography, FormGroup, TextField } from '@mui/material';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { SelectButton } from 'primereact/selectbutton';
import { Image } from 'primereact/image';
import EmailIcon from '../../../assets/images/icons/email.svg';
import { Checkbox } from "primereact/checkbox";
import getRequest, { postRequest, putRequest } from '../../../assets/helper/ApiHandler';
import { Toast } from "primereact/toast";
import { time } from '../../../assets/const/Constant'
import { regexPatterns } from '../../../assets/helper/RegexPattern';
var emailObject = {
    "report": '',
    "receiverEmail": '',
    "reportId": '',
    "scheduleType": '',
    "timeStamp": '',
    "isEnabled": ''
}
export default function EmailReports({ toggleDrawer }) {
    const toast = useRef(null);
    const [sendEmail, setSendEmail] = useState(null);
    const [selectReport, setSelectReport] = useState(null);
    const [report, setReport] = useState([]);
    const frequency = [
        { name: 'Daily', key: 'Daily' },
        { name: 'Weekly', key: 'Weekly' },
        { name: 'Monthly', key: 'Monthly' },
        { name: 'Yearly', key: 'Yearly' }
    ];
    const [reportTime, setReportTime] = useState(null);
    const options = ['AM', 'PM'];
    const [value, setValue] = useState(options[0]);
    const [checked, setChecked] = useState(false);
    const [emailsData, setEmailsData] = useState(emailObject);
    const [emailFormError, setEmailFormError] = useState(emailObject);

    useEffect(() => {
        getSelectedReports();
    }, [])

    const getSelectedReports = async () => {
        try {
            const reportsData = await getRequest(`/ui-report-filters`);
            setReport(reportsData);
        } catch (error) {
            if(toast.current){
                toast.current.show({ severity: "error", summary: 'Error', detail: error });
            }
        }
    };

    const handleSelectedReport = (e) => {
        setSelectReport(e.value);
        setEmailsData({
            ...emailsData,
            report: e.value
        });
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setEmailsData({
            ...emailsData,
            [id]: value
        });
    };


    const handleAMPMChange = (e) => {
        setValue(e.value);
        if (reportTime) {
            const hour24 = convertTo24hrFormat(reportTime.key, e.value);
            setEmailsData({
                ...emailsData,
                timeStamp: hour24.toString()
            });
        }
    };
    const handleFrequencyChange = (e) => {
        setSendEmail(e.value);
        setEmailsData({
            ...emailsData,
            scheduleType: e.value.name
        });
    };

    const handleTimeChange = (e) => {
        setReportTime(e.value);
        const hour24 = convertTo24hrFormat(e.value.key, value);
        setEmailsData({
            ...emailsData,
            timeStamp: hour24.toString()
        });
    };

    const convertTo24hrFormat = (hr, type) => {
        if (type === "PM" && hr !== "12") {
            return parseInt(hr) + 12;
        } else if (type === "AM" && hr === "12") {
            return 0;
        }
        return parseInt(hr);
    }

    const validationFormData = () => {
            let errors = {};
            let flag = false;
            if(!emailsData.report){
                errors.report = 'Report is required';
            }
            if (emailsData.receiverEmail) {
                if (!regexPatterns.email.test(emailsData.receiverEmail)) {
                    errors.receiverEmail = 'Email address required! E.g. example@email.com';
                }
            } else {
                errors.receiverEmail = 'Email is required';
            }
            if(!emailsData.scheduleType){
                errors.scheduleType = 'Frequency is required';
            }
            if(!emailsData.timeStamp){
                errors.timeStamp = 'Time is required';
            }
            setEmailFormError(errors);
            if(Object.keys(errors).length===0){
                flag=true;
            }
            return flag;
        }

    const handleCancel = (event) => {
        toggleDrawer(event);
    }

    const handleSubmit = async (event) => {
        if(!validationFormData()){
            toast.current.show({severity: 'error', summary: 'Error', detail: 'Check all the required fields.'})
            return;
        }
        try {
            const hour24 = convertTo24hrFormat(reportTime.key, value);
            const updatedEmailsData = {
                ...emailsData,
                timeStamp: hour24.toString()
            };

            const response = await postRequest(`/schedule-reports`, updatedEmailsData);
            if (response.data) {
                if(toast.current){
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Email report scheduled successfully' });
                }
                setTimeout(() => {
                    toggleDrawer(event);
                }, 500);
            } else {
                if(toast.current){
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to schedule email report' });
                }
            }
        } catch (error) {
            // toast.current.show({ severity: 'error', summary: 'Error', detail: error.message });
        }

    };

    return (
        <div>
            <Toast ref={toast} position="bottom-right"></Toast>
            <Box sx={{ width: '100%', padding: '1rem' }} className="popupContent emailReport">
                <div>
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} >
                                <Box className="card emailReport-form">
                                    <Box sx={{ minWidth: 0, flex: 1, padding: '1rem' }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Typography level="title-sm" className='fs-10-600'>Select report:</Typography>
                                                <Dropdown
                                                    // id="reportName"
                                                    options={report}
                                                    onChange={handleSelectedReport}
                                                    className={emailFormError.report ? "mr-2 p-invalid" : "mr-2"}
                                                    optionLabel="reportName"
                                                    value={selectReport}
                                                />
                                                 {emailFormError.report && (
                                                    <Typography level="title-sm" className="error-message fs-2">{emailFormError.report}</Typography>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Typography level="title-sm" className='fs-10-600'>To</Typography>
                                                <InputText
                                                    id="receiverEmail"
                                                    onChange={handleInputChange}
                                                    className={emailFormError.receiverEmail? "mr-2 p-invalid" : "mr-2"}
                                                    placeholder="" />
                                                    {emailFormError.receiverEmail && (
                                                    <Typography level="title-sm" className="error-message fs-2">{emailFormError.receiverEmail}</Typography>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Typography level="title-sm" className='fs-10-600'>Frequency</Typography>
                                                <Dropdown
                                                    id="scheduleType"
                                                    value={sendEmail}
                                                    onChange={handleFrequencyChange}
                                                    className={emailFormError.scheduleType ? "mr-2 p-invalid" : "mr-2"}
                                                    options={frequency}
                                                    optionLabel="name"
                                                    // className="auto-width h-30" 
                                                    />
                                                    {emailFormError.scheduleType && (
                                                    <Typography level="title-sm" className="error-message fs-2">{emailFormError.scheduleType}</Typography>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Typography level="title-sm" className='fs-10-600'>At:</Typography>
                                                <Dropdown
                                                    id="timeStamp"
                                                    value={reportTime}
                                                    onChange={handleTimeChange}
                                                    className={emailFormError.timeStamp ? "mr-2 p-invalid" : "mr-2"}
                                                    options={time}
                                                    optionLabel="name"
                                                    // className="auto-width h-30" 
                                                    />
                                                    {emailFormError.timeStamp && (
                                                    <Typography level="title-sm" className="error-message fs-2">{emailFormError.timeStamp}</Typography>
                                                )}
                                            </Grid>
                                            <Grid item xs={6}>
                                                <SelectButton
                                                    value={value}
                                                    onChange={handleAMPMChange}
                                                    allowEmpty={false}
                                                    options={options} />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>

                                            <Grid item xs={12}>
                                                <div className='message-card fs-10-600'>Emails will be sent at 8:00 AM EST, your Omega timezone configured in <Button className='inline-txt-btn-blue'>settings</Button></div>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Button type="button" className='filter-btn'><Image src={EmailIcon} alt="Image" width="24" />Send email now</Button>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={2} className='no-result'>
                                            <Grid item xs={12}>
                                                <Box className="no-result-checkbox">
                                                    <Checkbox inputId="no-results" name="no-results" value="No results" onChange={e => setChecked(e.checked)} checked={checked} />
                                                    <label htmlFor="no-results" className="ml-2 fs-2-500">Don’t send email if there aren’t results</label>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                    <Box sx={{ minWidth: 0, display: 'flex', padding: '1rem', justifyContent: 'end' }} gap={2} className="form-footer">
                                        <Button type="button" className="button-style-2" label="Cancel" size="small" onClick={handleCancel}></Button>
                                        <Button type="button" className="button-style-1" label="Apply" size="small" onClick={handleSubmit}></Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </div>
            </Box>
        </div>

    );
}